<template>
  <div class="modal--consumption_data_import">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <span class="card-times" @click="closeModal">&times;</span>
      <hr class="modalCustom__header-border" />
    </div>

    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else class="modalCustom__body">
      <p v-if="file" class="">for {{ file.name }}</p>
      <div class="row">
        <div class="col-xl-6">
          <label for="select_type" class="control-label">{{ $t('Type') }} *</label>
          <multiselect
            v-model="form.consumption_category_id"
            :options="consumption_categories.map((category) => category.id)"
            id="select_type"
            :loading="loading"
            :disabled="true"
            :multiple="false"
            :close-on-select="true"
            :show-labels="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <div>
                <span class="option__title">{{ consumption_categories.find((x) => x.id === props.option).name }}</span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ consumption_categories.find((x) => x.id === props.option).name }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="col-xl-6">
          <label for="select_supplier" class="control-label">{{ $t('Energy Supplier') }} *</label>
          <multiselect
            v-model="form.energy_supplier_id"
            @search-change="saveSearchValue($event)"
            :options="energy_suppliers.map((supplier) => supplier.id)"
            label="name"
            id="select_supplier"
            :loading="loading"
            :multiple="false"
            :close-on-select="true"
            :show-labels="false"
          >
            <template slot="singleLabel" slot-scope="props">
              <div>
                <span class="option__title">{{ energy_suppliers.find((x) => x.id === props.option).name }}</span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ energy_suppliers.find((x) => x.id === props.option).name }}</span>
              </div>
            </template>
            <template>
              <div slot="noResult" @click="createSupplier(searchValue)">
                Request New Supplier: <span class="text-primary"> {{ searchValue }} </span>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <hr />
      <div class="row" v-for="(meter, index) in form.meters" v-bind:key="index">
        <h4 class="col-md-12">
          Meter {{ index + 1 }}
          <span v-if="meter.meter_number">({{ meter.meter_number }})</span>
          <i
            v-if="index > 0"
            class="fas fa-minus-square ml-3 cursor-pointer text-danger"
            @click="removeMeter(index)"
          ></i>
        </h4>
        <div class="col-xl-4">
          <fg-input type="text" label="Account Number *" placeholder="51766033088" v-model="meter.account_number">
          </fg-input>
        </div>
        <div class="col-xl-4">
          <fg-input type="text" label="Meter number *" placeholder="988284335" v-model="meter.meter_number"> </fg-input>
        </div>
        <div class="col-xl-4">
          <fg-input
            type="number"
            :label="'Total usage ' + getUnit() + ' *'"
            placeholder="1085"
            v-model="meter.total_usage"
          >
          </fg-input>
        </div>
        <div class="col-xl-4">
          <fg-input
            type="number"
            :label="'Amount Due (' + '$' + ') *'"
            placeholder="1200.99"
            v-model="meter.amount_paid"
          >
          </fg-input>
        </div>
        <div class="col-xl-4">
          <fg-input type="date" label="Date *" v-model="meter.end_date"> </fg-input>
        </div>
        <div class="col-xl-4">
          <fg-input type="number" label="Number of days *" placeholder="30" v-model="meter.days"> </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="w-full text-center">
          <h5><span @click="addMeter()" class="cursor-pointer">&plus; Add Meter</span></h5>
        </div>
      </div>

      <div class="row float-right">
        <p-button v-if="file" class="mr-2" type="danger" @click.native.prevent="remove()"> remove </p-button>
        <p-button id="save" type="success" @click.native.prevent="save()"> Save </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import ConsumptionCategoriesController from '@/controllers/Consumption/ConsumptionCategoriesController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import EnergySupplierController from '@/controllers/Consumption/EnergySupplierController';

export default {
  name: 'ConsumptionFileUploadFormModal',
  components: { MoonLoader },
  props: {
    data: {},
  },
  data() {
    return {
      consumption_categories: [],
      energy_suppliers: [],
      form: {},
      loading: false,
      file: null,
      searchValue: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.getConsumptionCategories();
    await this.getEnergySuppliers();
    this.setFile();
    this.setForm();
    this.loading = false;
  },
  methods: {
    async getConsumptionCategories() {
      this.consumption_categories = await ConsumptionCategoriesController.index();
    },
    getUnit() {
      if (this.form.consumption_category_id)
        return (
          '(' + this.consumption_categories.find((x) => x.id === this.form.consumption_category_id).unit.text + ')'
        );
      else return '';
    },
    closeModal: function () {
      this.form = {};
      this.$emit('close');
    },
    save: function () {
      this.form.consumption_category = this.consumption_categories.find(
        (x) => x.id === this.form.consumption_category_id
      );
      this.$emit('submit', { form: this.form, file: this.file });
      this.closeModal();
    },
    setFile() {
      this.file = this.data.file;
      return this.file;
    },
    setForm() {
      if (this.data.form) {
        this.form = this.data.form;
      }
    },
    async getEnergySuppliers() {
      this.energy_suppliers = await EnergySupplierController.index();
    },
    async saveSearchValue(searchValue) {
      this.searchValue = searchValue;
    },
    async createSupplier(name) {
      let energy_supplier = await EnergySupplierController.store({ name: name });
      this.energy_suppliers.push(energy_supplier);
    },
    remove() {
      this.$emit('deleted', this.file);
      this.closeModal();
    },
    addMeter() {
      this.form.meters.push({
        meter_number: null,
        end_date: null,
        total_usage: null,
        amount_paid: null,
        account_number: null,
        days: null,
      });
    },
    removeMeter(index) {
      this.form.meters.splice(index, 1);
    },
  },
};
</script>

<style scoped></style>
